require('../filter-editor-modal.component.scss');
require('./contentprocessing-filter-editor.component.scss');


export class ContentprocessingFilterEditorController {

  constructor($scope, CurrentModelService, $http, $cookies) {
    this.$scope = $scope;
    this.$cookies = $cookies;
    this.CurrentModelService = CurrentModelService;
    this.$http = $http;
    this.$scope.api_error = false;
  }

  $onInit() {

    this.$scope.filter = this.filter.filter;
    if (this.$scope.filter.cpservices == undefined) {
        this.$scope.filter.cpservices = [];
        const defaults = {
            api_address: this.$scope.filter.api_address ? this.$scope.filter.api_address: '',
            api_port: this.$scope.filter.api_port ? this.$scope.filter.api_port: '',
            pool_size: this.$scope.filter.pool_size ? this.$scope.filter.pool_size: 1,
            active: true,
        };
        this.addServer(defaults);
    } else {
        this.$scope.filter.cpservices.forEach((cpservice, index) => {
            this.checkServer(index);
        });
    }
  }

  addServer(defaults) {
      this.$scope.filter.cpservices.push({
          api_address: defaults && defaults.api_address ? defaults.api_address: '',
          api_port: defaults && defaults.api_port ? defaults.api_port: 9090,
          pool_size: defaults && defaults.pool_size ? defaults.pool_size: 1,
          active: defaults && defaults.active !== undefined ? defaults.active: false,
          la: 'n/a',
      });
//       console.log(this.$scope.filter.cpservices);
  }


  checkServer(idx) {
      const cpservice = this.$scope.filter.cpservices[idx];
      cpservice.status = '?';
      this.$http.post('/cp_queue/check_cpservice/', cpservice, {
        headers: {
          'X-CSRFToken': this.$cookies.get('csrftoken'),
        }
      })
        .then(({
            data,
            status
        }) => {
            console.log(data);
            cpservice['status'] = data['status'];
            const la = data['load_average'];
            if (cpservice.pool_size > 0 && la !== 'n/a') {
                cpservice['la'] = la/cpservice.pool_size*80;
                if (cpservice['la'] > 100) {
                    cpservice['la'] == 100;
                }
            } else {
                cpservice['la'] = 'n/a';
            }
        });
  }

  removeServer(idx) {
      this.$scope.filter.cpservices.splice(idx, 1);
  }

}

export const ContentprocessingFilterEditorComponent = {
  bindings: {
    filter    : '<',
  },
  template: require('./contentprocessing-filter-editor.component.html'),
  controller: ContentprocessingFilterEditorController,
};



// WEBPACK FOOTER //
// ./src/filter/editor/spec-forms/contentprocessing-filter-editor.component.js